
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[bid]",
      function () {
        return require("private-next-pages/blog/[bid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[bid]"])
      });
    }
  